import { render, staticRenderFns } from "./UltimasNotificacoesIndex.vue?vue&type=template&id=16fba294&scoped=true&"
import script from "./UltimasNotificacoesIndex.vue?vue&type=script&lang=js&"
export * from "./UltimasNotificacoesIndex.vue?vue&type=script&lang=js&"
import style0 from "./UltimasNotificacoesIndex.vue?vue&type=style&index=0&id=16fba294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fba294",
  null
  
)

export default component.exports